import React from "react";
import StateResult from './stateresult';
import ElectionAction from "../../Actions/ElectionAction";
import PartyHeaders from "./components/partyheaders";
import PartyResult from "./components/partyresult";

export default class ElectionResult extends React.Component {

  constructor(props) {
    super(props);

    this.state = {};
    this.fetchNationaldata = this.fetchNationaldata.bind(this);
  }

  componentDidMount() {
    window.uplimit = 542;
    this.fetchNationaldata();
  }

  fetchNationaldata() {
    let totalcount = 0;
    let jsondata = {};
    let queryparams = this.props.queryparams;
    let data = {};
    let time = 30000;
    try {
      data['islive'] = queryparams['islive'];
    } catch (e) {

    }
    let response = ElectionAction.nationalwise(data);

    if (typeof response == "object") {
      response.then((result) => {
        jsondata = result['data'];
        try {
          jsondata = jsondata['data']['data'];
          if (Object.keys(jsondata).length > 0) {
            try {
              // console.log(jsondata);
              Object.keys(jsondata).map((key) => {
                totalcount = totalcount + jsondata[key]['totalSeats'];
              })
              // console.log

              if (totalcount > window.uplimit || totalcount < 0) {
                // console.log("error");
              } else {
                // console.log("succ");
                this.setState({ ...jsondata }, () => {

                });
              }

              setTimeout(() => {
                this.fetchNationaldata();
              }, time);

            } catch (e) {
              console.log("storagedata cond0", 'error', e.message);
              setTimeout(() => {
                this.fetchNationaldata();
              }, time);
            }

          } else {
            console.log("storagedata cond1", 'error');
            setTimeout(() => {
              this.fetchNationaldata();
            }, time);

          }
        } catch (e) {
          console.log("storagedata cond2", 'error');
          setTimeout(() => {
            this.fetchNationaldata();
          }, time);

        }


      }).catch((error) => {
        console.log("storagedata cond3", 'error');
        setTimeout(() => {
          this.fetchNationaldata();
        }, time);

      });
    } else {
      console.log("storagedata cond4", 'error');
      setTimeout(() => {
        this.fetchNationaldata();
      }, time);

    }


  }

  render() {
    let nationalRes = this.state;
    let summation = 0
    if (Object.keys(nationalRes).length > 0) {
      try {

        Object.keys(nationalRes).map((index) => {
          if (nationalRes[index]['totalSeats']) {
            summation = summation + parseInt(nationalRes[index]['totalSeats']);
          }
        });
        summation = (summation + "").length >= 2 ? summation : "0" + summation;
      } catch (e) {
        console.log(e.message);
      }
      
      return (

        <div className="election_section_main">
          {/* <h2 className="electionwith_heading">#Election2019 with Vikram</h2> */}
          <section className="election_section" key={Math.random()}>
            <h4 className="election_result_title">{"national tally (" + summation + "/542)"}</h4>

            <table className="election_result_main ">

              <PartyHeaders data={nationalRes} />
              <PartyResult data={nationalRes} isremove={1} />
            </table>
          </section>
          <StateResult queryparams={this.props.queryparams} />
        </div>

      );
    } else {
      return <div></div>
    }



  }
}
